import React, { useRef } from "react";

import { ClusterView } from "src/components/clusterFilters/cluster";
import { ModuleType, PropertyType } from "src/types/clusterFilters";

import { hideInputField } from "src/services/reports.service";

import cx from "classnames";
import styles from "./entityFilters.module.scss";
import _ from "lodash";

export interface Filter {
  property: {
    type: PropertyType;
  };
  operator: string;
  value: any[];
}
interface FilterEditorProps {
  filters: Filter[];
  onChange: (updatedFilters: Filter[]) => void;
  show: boolean;
  onClose?: () => void;
}

const FilterEditor: React.FC<FilterEditorProps> = ({
  filters = [],
  onChange,
  show,
  onClose = () => {},
}) => {
  const prevFiltersRef = useRef<Filter[]>([]);

  //Filtering out only the needed fields
  const normalizeFilters = (filters: Filter[]) =>
    (filters || [])
      .filter((filter) => {
        const allowEmptyValues = hideInputField(filter.operator as any);
        const hasNonEmptyValue = _.size(filter.value) > 0;
  
        return hasNonEmptyValue || allowEmptyValues;
      })
      .map(({ property, value, operator }) => ({
        property,
        value,
        operator,
      }));
  
  //Checking if the new filters are different from the previous ones
  const handleClusterViewFiltersChange = (updatedFilters: any[]) => {
    const normalizedNew = normalizeFilters(updatedFilters);
    const normalizedPrev = normalizeFilters(prevFiltersRef.current);

    if (!_.isEqual(normalizedNew, normalizedPrev)) {
      prevFiltersRef.current = updatedFilters;
      onChange(normalizedNew);
    } else {
    }
  };

  return (
    <div className={cx(styles.filterEditor, { [styles.show]: show })}>
      <div className={styles.inner}>
        <ClusterView
          key={show ? 'editor-open' : 'editor-closed'}
          cluster={null}
          handleFilterUpdate={handleClusterViewFiltersChange}
          moduleType={ModuleType.REPORTS}
        />
      </div>
    </div>
  );
};

export default FilterEditor;
